import { render } from "./tab-nav.vue?vue&type=template&id=447d6b67"
import script from "./tab-nav.vue?vue&type=script&lang=js"
export * from "./tab-nav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__